// Sposta il blocco quantita' dentro il modal Customily SOLO quando e' aperto,
// lo riporta sulla pagina prodotto quando il modal si chiude.
// Luca Siviero

document.addEventListener("customily:ready", () => {
    const eligibleCollectionId = 530342838540;
    const collectionIds = window.productCollectionIds || [];
    const isEligible = collectionIds.some((id) => id == eligibleCollectionId);

    if (!isEligible) return;

    let initialized = false;
    let isInside = false;
    let quantityBlock, checkboxContainer, wrapper, placeholder;

    function isModalVisible() {
        const modalDesktop = document.querySelector(".customily-modal-container");
        const modalMobile = document.querySelector(".csh-product-customizer-modal");
        return (
            (modalDesktop && modalDesktop.style.display !== "none") ||
            (modalMobile && modalMobile.style.display !== "none")
        );
    }

    function updateContainerHeight() {
        const container = document.querySelector(".customily_sets-container");
        if (!container) return;
        const visibleOption = container.querySelector('.customily_option[style*="translateX(0%)"]');
        if (!visibleOption) return;
        const height = visibleOption.scrollHeight;
        container.style.setProperty("height", height + "px", "important");
    }

    function syncPosition() {
        if (!initialized) return;

        const modalVisible = isModalVisible();

        if (modalVisible && !isInside) {
            checkboxContainer.parentElement.insertBefore(wrapper, checkboxContainer);
            if (window.innerWidth < 576) {
                wrapper.style.cssText = "display:flex; width:100%; justify-content:center; margin-top:20px;";
            } else {
                wrapper.style.cssText = "";
            }

            // Sposta anche il box sconti subito dopo il wrapper dentro il modal
            const discountBox = document.getElementById('wr-discount-box');
            if (discountBox) {
                wrapper.insertAdjacentElement("afterend", discountBox);
            }

            isInside = true;
            updateContainerHeight();
        } else if (!modalVisible && isInside) {
            placeholder.parentElement.insertBefore(wrapper, placeholder);
            wrapper.style.cssText = "";

            // Riporta il box sconti dopo il wrapper sulla pagina prodotto
            const discountBox = document.getElementById('wr-discount-box');
            if (discountBox) {
                wrapper.insertAdjacentElement("afterend", discountBox);
            }

            isInside = false;
        }
    }

    function setup() {
        if (initialized) return;

        quantityBlock = document.querySelector('[data-block-type="quantity-selector"]');
        const fakeCheckbox = document.querySelector('.checkbox-container input[name="properties[Quantità]"]');

        if (!quantityBlock || !fakeCheckbox) return;

        checkboxContainer = fakeCheckbox.closest(".checkbox-container");
        if (!checkboxContainer) return;

        wrapper = document.createElement("div");
        wrapper.className = "wr-quantity-selector-wrapper";

        quantityBlock.parentElement.insertBefore(wrapper, quantityBlock);
        wrapper.appendChild(quantityBlock);

        placeholder = document.createComment("quantity-selector-placeholder");
        wrapper.parentElement.insertBefore(placeholder, wrapper);

        const optionNameDiv = document.querySelector('[opt-id="5"] .option_name');
        if (optionNameDiv) {
            optionNameDiv.style.width = "100%";
            optionNameDiv.style.maxWidth = "200px";
            optionNameDiv.style.alignSelf = "start";
            optionNameDiv.style.textOverflow = "ellipsis";
            optionNameDiv.style.overflow = "hidden";
            optionNameDiv.style.whiteSpace = "nowrap";
            optionNameDiv.style.marginLeft = "0px";
        }

        checkboxContainer.style.display = "none";

        const optionContent = document.querySelector('[opt-id="5"] .cl-option-content');
        if (optionContent && window.innerWidth >= 768) {
            const label = document.createElement("span");
            label.textContent = "Quantità";
            label.style.cssText = "display:block; font-size:14px;";
            optionContent.insertBefore(label, optionContent.firstChild);
        }

        const resizeObserver = new ResizeObserver(updateContainerHeight);
        const container = document.querySelector(".customily_sets-container");
        if (container) resizeObserver.observe(container);

        initialized = true;
    }

    // Setup con polling, si ferma appena inizializzato
    let setupAttempts = 0;
    const setupInterval = setInterval(() => {
        setup();
        setupAttempts++;
        if (initialized || setupAttempts > 30) clearInterval(setupInterval);
    }, 300);

    // Observer per apertura/chiusura modal — osserva SOLO attributi style
    // (non childList/subtree generico per evitare cascade di mutazioni)
    const observer = new MutationObserver(() => { syncPosition(); updateContainerHeight(); });
    observer.observe(document.body, { attributes: true, childList: true, subtree: true });
});